import { Box } from '@chakra-ui/react';
import { AddUserIcon } from 'Tokens/Icons/Function';

export const EmptyOwner = ({ size }: { size?: string }) => {
  return (
    <Box bg="bg.unknown.accent" boxSize={size ?? '28px'} borderRadius="50%" position="relative">
      <AddUserIcon
        color="text.onAccent"
        position="absolute"
        left="50%"
        top="50%"
        boxSize="60%"
        transform="translate(-50%, -50%)"
      />
    </Box>
  );
};
